import { ASubheaderSize, ASubheaderTag } from '../../atoms/ASubheader';

export interface SnackbarCTA {
  label: string;
  url?: string;
  callback?: () => void;
  isLink?: boolean;
  isExternalLink?: boolean;
}

export interface MSnackbarProps extends React.HTMLAttributes<HTMLDivElement> {
  modalType?: SNACKBAR_MODAL_TYPE;
  successMessage?: string;
  errorMessage?: string;
  ctas?: SnackbarCTA[];
  autoHideDuration?: number;
  iconClass?: string;
  subheaderSize?: ASubheaderSize;
  subheaderElement?: ASubheaderTag;
  closeAriaLabel?: string;
  onClose?: () => void;
}

export const SNACKBAR_MODAL_TYPE = {
  SUCCESS: 'Success',
  ERROR: 'Error',
} as const;
export type SNACKBAR_MODAL_TYPE = (typeof SNACKBAR_MODAL_TYPE)[keyof typeof SNACKBAR_MODAL_TYPE];
